<template>
    <div class="index_page">
      <Header></Header>
      <div class="index_top contain" v-loading="loading">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'AppResourceAdd', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box">
          <dl v-for="(item, k) in configs">
            <dt>{{item.name}}：</dt>
            <dd>
              <span :class="currentIndexs[k]==0?'all':''" @click="selectItem(0, k)">不限</span>
              <template v-for="(val, key) in item.children">
                <span @click="selectItem(val.id, k, val)" :class="(currentIndexs[k] == val.id)?'all':''">{{val.name}}</span>
              </template>
              
            </dd>
            <div class="clear"></div>
          </dl>
        </div>
       
      
        <div class="contain">
          <div class="sear_box">
            <div class="search">
              <el-input placeholder="请输入关键字" v-model="keyword">
                <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
              </el-input>
            </div>
            <div class="btn_box">
              <ul class="clearfix">
                <li>
                  <router-link :to="{ name: 'AppResourceMy'}">
                  <span>
                    <img src="../assets/icon1.png" alt="我的资源">
                    <div class="tit">我的资源</div>
                  </span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'AppResourceAdd'}">
                  <span>
                    <img src="../assets/icon2.png" alt="我要上传">
                    <div class="tit">我要上传</div>
                  </span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="clear"></div>
          </div>
          <div class="list_box">
            <ul>
              <template v-for="(item,index) in List">
                <li :class="item.attachment?item.attachment.extension:''">
                  <el-row :gutter="20">
                    <el-col :span="18">
                      <div class="list_lf">
                        <router-link :to="{ name: 'AppResourceInfo', params: {id: item.id}}"><span class="tit">{{item.title}}</span></router-link>
                        <div class="cont">{{item.desc}}</div>
                        <div class="tip"><span class="date" v-show="false">{{item.created_at}}</span><i class="i" v-show="false">/</i><router-link :to="{ name: 'AppResourcePerson', params: {id: item.user_id}}"><span class="author" >作者：{{(item.user)?item.user.username:''}}</span></router-link><i class="i" v-show="false">/</i><span class="author" v-show="false">下载次数：{{item.download_count}}</span></div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="list_rt">
                        <a :href="item.attachment?item.attachment.file:''" target="_blank">
                          <el-button>马上下载</el-button>
                        </a>
                      </div>
                    </el-col>
                  </el-row>
                  
                  
                </li>
              </template>
            </ul>
            <el-pagination :page-size="size" @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
      </div>
      <Footer></Footer>
    </div>
  </template>
  <script>
  import Header from '@/components/header'
  import Footer from '@/components/footer' 

  import { setCache, getCache } from '@/utils/cache'
  import { getListOptions } from '@/utils/app'

  import { index as indexApi, resIndex as resIndexApi, resourceIndex, resourceDelete, resourceAddLogs } from '@/api/index'
  export default {
    data() {
      return {
        configs: [],
        currentIndexs: [0,0,0],
        loading: true,
        CourseList: [],
        GradeList: [],
        CourseChildren: [],
        TypeList: [],
        index_course: 0,
        index_grade: 0,
        index_type: 0,
        keyword: '',
        List: [{
        }],
        total: 0,
        size: 10,
        count: 0,
        page: 1,
        key: 0,
        user: this.$store.state.user,
        nav: {
          id: '100',
          name: '资源专区'
        },
        class_id: 0
      }
    },
    components: {
      Header, Footer
    },
    computed: {},
    mounted() {},
    created() {
      this.getConfig()
      if(this.$route.query.title) this.keyword = this.$route.query.title
      if(this.$route.query.class_id) {
        this.class_id = this.$route.query.class_id
        this.currentIndexs[1] = this.class_id
      }
      this.getList()
    },
  
    methods: {
      getConfig() {
        let config = getCache('configs')
        this.configs = config
      },
      getList() {
        resIndexApi({page: this.page, subject_id: this.currentIndexs[1], class_id: this.currentIndexs[0], type_id: this.currentIndexs[2], keyword: this.keyword}).then(res=>{
          this.List = res.data
          this.total = res.total
          this.size = res.per_page
          this.loading = false
        })
      },
      handleCurrentChange(page){
        this.page = page
        this.getList()
      },
      selectItem(val, k, item) {
        let config = getCache('configs')
        if(k == 0 && item) { 
          let arr = getListOptions(item.name, config[1]['children'])
          config[1]['children'] = arr
          this.$set(this.configs, 1, config[1])
        }else if(!item) {
          this.configs = config
        }
        this.$set(this.currentIndexs, k, val)
        this.getList()
      },
      deleteData(id, index) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const data = {
                id: id
              }
              resourceDelete(data).then(res => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.List.splice(index, 1)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
      },
      addLogs(id, index) {
        resourceAddLogs({id: id}).then(res=> {
  
        })
      },
      openUrl(){
        window.open(window.location.href)
      }
    }
  }
  
  </script>
  <style scoped>
  .contain{ }
  .list_box li .list_rt{ float: right; }
  .list_box li .list_rt .el-button{ position: static; margin:0 5px 6px; height:30px; line-height:30px; padding:0px 15px;}
  .list_box li .list_rt .el-button.write,
  .list_box li .list_rt .el-button.delete{ background:#fd9627;}
  
  .index_top {
    z-index:1;
  }
  .index_top .box {
     background-color: #fff;
     padding: 20px 80px;
  }
 .index_top .box dl {
     margin-bottom:25px;
}
 .index_top .box dt {
     float: left;
     color:#000;
     font-size:16px;
     line-height:34px;
}
 .index_top .box dd span {
     float: left;
     display:block;
     cursor: pointer;
     color:#000;
     font-size:16px;
     margin:0 15px;
     padding:3px 8px;
}
 .index_top .box dd span.all, .index_top .box dd span:hover {
     color:#fff;
     background:#1680ff;
     border-radius: 5px;
}
.index_btm {
}
 .sear_box {
     background:#fff;
     padding:15px 100px;
}
 .sear_box .search {
     width: 729px;
     float: left;
}
  .btn_box {
     float: right;
     margin-right: 20px;
}
  .btn_box li {
     float: left;
     margin-left:20px;
}
  .btn_box li span {
     display: block;
     cursor: pointer;
     text-align: center;
}
  .btn_box li span img {
     height:32px;
}
 .btn_box li span .tit {
     font-size:16px;
     color:#4b98ff;
     margin-top:3px 
}
   .sear_box .search .el-input__inner {
    border: 1px solid #19a97b;
    height: 55px;
    line-height: 55px;
    font-size: 18px;
    color: #8c8b8b;
    width: 655px;
    border-radius: 7px 0 0 7px;
  }
  
   .sear_box .search .el-input-group__append {
    background: #19a97b;
    border: 1px solid #19a97b;
    color: #fff;
    font-size: 30px;
    border-radius: 0 7px 7px 0;
  }
  
  </style>
  